import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";

import { FaLock } from "react-icons/fa";

function ReloginDialog({ open, onConfirm }) {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: "14px",
        },
      }}
    >
      <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
        <VuiTypography variant="lg" fontWeight="bold">
          Password Updated
        </VuiTypography>
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", px: 4 }}>
        <VuiTypography variant="body2">Your password has been updated successfully.</VuiTypography>
        <VuiTypography variant="caption">For security reasons, please sign in again.</VuiTypography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <VuiButton
          color="success"
          variant="gradient"
          onClick={onConfirm}
          startIcon={<FaLock size={14} />}
          sx={{ minWidth: 180 }}
        >
          Sign In Again
        </VuiButton>
      </DialogActions>
    </Dialog>
  );
}

export default ReloginDialog;
